export class ValidationConstants {

    static readonly ENG_RU_LETTERS_PATTERN: string = "[a-zA-Zа-яА-я]*";
    static readonly MIN_EMAIL_LENGTH: number = 6;
    static readonly MAX_EMAIL_LENGTH: number = 100;
}